import { Component, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from './services/theme/theme.service';
import { StorageService } from './services/storage/storage.service';
import { AuthenticationService } from './services/authentication/authentication.service';
import { PriorityTypesService } from './services/priority_types/priority-types.service';
import { Platform } from '@ionic/angular';
import { Network } from '@capacitor/network';
import { PlayerNotesService } from './services/playerNotes/player-notes.service';
import { ToastService } from './services/toast/toast.service';
import { NetworkService } from './services/network/network.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private storage: StorageService,
    private themeService: ThemeService,
    public translate: TranslateService,
    private authentication: AuthenticationService,
    private priorityTypes: PriorityTypesService,
    private playerNotesService: PlayerNotesService,
    private toast: ToastService,
    private networkService: NetworkService
  ) {
    this.themeService.initTheme();
    // Disable warnings: window.console.warn = function(){};

    this.translate.setDefaultLang("en");
    this.translate.use(this.translate.getBrowserLang() || "en");

    this.storage.get("DATABASE").then(databaseName => {
      if (databaseName) {
        this.authentication.checkForUser().subscribe(user => {
          this.priorityTypes.allowPriorityTypes(user.id).then(_device => {
            _device.subscribe(device => {
              if(device) { this.storage.set("data_save", device.data_save_mode); }
            });
          });
        });
      }
    });

    Network.addListener('networkStatusChange', status => {
      this.networkService.setNetworkStatus(status.connected);
      if (status.connected) {
        // When network comes back online, auto save player notes saved in local storage
        this.playerNotesService.saveNotesFromLocalStorage();
      }
    });
  }
}
